let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("sMscd")).then(() => parcelRequire('7DsSj'));